import { createContext } from 'react'

import type { FeatureFlagContextValue } from '@/shared/libs/launchdarkly/types'

export const FeatureFlagContext = createContext<FeatureFlagContextValue>({
  isReady: false,
  variation: (_flag, defaultValue) => defaultValue,
  identify: () => Promise.resolve(),
})
